import { _isNotBlank } from '@/littledash.ts';
import { type FC } from 'react';
import { type SequenceToken } from './TemplateSequenceEditor.tsx';
import styles from './SampleNameTemplateBuilder.module.scss';

const PLACEHOLDER_VALUES: Record<string, string> = {
  study_code: 'STD001',
  sample_type: 'BLD',
  animal_id: '1_1',
  group_number: '1',
  timepoint: '1H',
};

const resolveToken = (token: SequenceToken): string => {
  if (typeof token.customValue === 'string') {
    return token.customValue;
  }
  if (token.definition.type === 'separator') {
    return token.definition.value;
  }
  if (token.definition.value === 'sample_meta') {
    return token.metadataGlossaryTitle ?? 'Meta';
  }
  return PLACEHOLDER_VALUES[token.definition.value] ?? token.definition.label;
};

interface TemplatePreviewProps {
  sequence: Array<SequenceToken>;
}

/**
 * Renders a live sample name preview using placeholder values for each token in the sequence.
 */
export const TemplatePreview: FC<TemplatePreviewProps> = ({ sequence }) => {
  const name = sequence.map(resolveToken).join('');
  return (
    <div className={styles.previewContainer}>
      <p className={styles.previewLabel}>Preview</p>
      <div className={styles.preview}>
        {_isNotBlank(name) ? (
          <p className={styles.previewName}>{name}</p>
        ) : (
          <p className={styles.previewEmpty}>Add components to see a preview</p>
        )}
      </div>
    </div>
  );
};
